const backendUrl = 'https://backend.leoticket.de';

module.exports = {
	merchantId: 'fef',
	backendUrl,
	pcuiBaseUrl: 'https://fractofilm.leoticket.de',
};
